export default __webpack_public_path__ + "static/media/id.30f086d3.svg";